import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export const CustomInput = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiInputBase-root": {
    height: "35px",
    borderRadius: "4px",
    // backgroundColor: "#F2F0F9",
    backgroundColor: "#FFFFF",
    color: "#413755",
    padding: "0 0px",
    boxSizing: "border-box",
    transition: "all 0.3s ease-in-out",
    fontFamily: "Outfit",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#EAE8F4",
    },
    "&:hover fieldset": {
      borderColor: "#C3A0CD",
    },
    "&.Mui-focused": {
    // backgroundColor: "#F2F0F9",
      backgroundColor: "#FFFFF",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#C3A0CD",
    },
  },
  "& .MuiInputBase-input": {
    fontWeight: 500,
    // 👇 Remove number input spinners
    MozAppearance: "textfield", // Firefox
  },
  // Chrome, Safari, Edge
  "& input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "& input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
}));
